import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'customers-history',
  storeModule.createStoreModule('customers-history', {
    fetchFormURL: ({ id }) => `customers/${id}/history/new`,
    updateURL: ({ id: { customerId, factId } }) => `customers/${customerId}/history/${factId}/change`
  })
)
